'use strict';

var style = require('../style/style.cjs');
var compose = require('../compose/compose.cjs');
var breakpoints = require('../breakpoints/breakpoints.cjs');

function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = style.default({
  prop: 'width',
  transform: sizingTransform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      const breakpoint = props.theme?.breakpoints?.values?.[propValue] || breakpoints.values[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (props.theme?.breakpoints?.unit !== 'px') {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return breakpoints.handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = style.default({
  prop: 'minWidth',
  transform: sizingTransform
});
const height = style.default({
  prop: 'height',
  transform: sizingTransform
});
const maxHeight = style.default({
  prop: 'maxHeight',
  transform: sizingTransform
});
const minHeight = style.default({
  prop: 'minHeight',
  transform: sizingTransform
});
style.default({
  prop: 'size',
  cssProperty: 'width',
  transform: sizingTransform
});
style.default({
  prop: 'size',
  cssProperty: 'height',
  transform: sizingTransform
});
const boxSizing = style.default({
  prop: 'boxSizing'
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);

exports.boxSizing = boxSizing;
exports.height = height;
exports.maxHeight = maxHeight;
exports.maxWidth = maxWidth;
exports.minHeight = minHeight;
exports.minWidth = minWidth;
exports.sizingTransform = sizingTransform;
exports.width = width;
//# sourceMappingURL=sizing.cjs.map
